import { useNavigate } from 'react-router-dom';
import { FullScreenLoadingBox } from 'components';
import { ROUTES } from 'core';
import { selectBasketExams } from 'store/basket/basketSlice';
import { useAppSelector } from 'store';

import { OidcContext, OidcRedirectCallback } from '@britishcouncil/react-oidc-auth';

interface OidcCallbackProps {
  errorCallback?: (error: Error) => void;
}

const logError = (error: Error) => console.log(error);

export const LoginCallback = ({ errorCallback = logError }: OidcCallbackProps) => {
  const navigate = useNavigate();
  const userManager = OidcContext.useAuth();
  const exams = useAppSelector(selectBasketExams);

  const onError = async (error: Error) => {
    if (!!error && error.message === 'No matching state found in storage') {
      return userManager.signinRedirect();
    }
    if (errorCallback) errorCallback(error);
    navigate(ROUTES.LOGIN_ERROR);
  };

  return (
    <OidcRedirectCallback
      redirectTo={exams.length > 0 ? ROUTES.TEST_TAKER_DETAILS : ROUTES.COUNTRY_SELECTOR}
      errorCallback={onError}
    >
      <FullScreenLoadingBox />
    </OidcRedirectCallback>
  );
};
